import { FormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { Revisione53State } from '../../../../store/revisione53.reducers';
import { withChangeDebounced } from '@shared/operators/with-change-debounced.operator';
import { updateVerbaleOnStore } from '@core/helpers/create-validator.helper';
import { MyVerbale } from '../../../../models/interfaces/revisione.interface';
import { cloneDeep } from 'lodash-es';
import { getNormeSpaOrdinarioControl } from '../validators/helpers/norme-spa-ordinario-form-validators.helper';

export const setNormeSpaOrdinarioSpoSpecificListeners = (form: FormGroup, store: Store<Revisione53State>): void => {
    my_CkSpoSindaciRevisori(form, store);
};

const my_CkSpoSindaciRevisori = (form: FormGroup, store: Store<Revisione53State>): void => {
    const my_CkSpoSindaciRevisoriControl = getNormeSpaOrdinarioControl(form, 'my_CkSpoSindaciRevisori');
    my_CkSpoSindaciRevisoriControl.valueChanges.pipe(withChangeDebounced(my_CkSpoSindaciRevisoriControl)).subscribe((my_CkSpoSindaciRevisori) => {
        const correctValue = my_CkSpoSindaciRevisori === '1' ? '1' : '';
        getNormeSpaOrdinarioControl(form, 'my_CkSpoSindaciSceltiCoerenza').patchValue(correctValue, { emitEvent: false });

        updateVerbaleOnStore(store, (myVerbale) => {
            const myVerbaleClone: MyVerbale = cloneDeep(myVerbale);
            myVerbaleClone.my_SezioneI__Rilevazione.my_AmministrazioneControllo.my_NormeSpaOrdinario.my_CkSpoSindaciSceltiCoerenza = correctValue;
            return myVerbaleClone;
        });
    });
};
